
















































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { DropDownItem, DropdownGroup } from './types/dropdownItem';
import AppDropdownItem from './AppDropdownItem.vue';

@Component({
  components: { AppDropdownItem },
})
export default class AppDropdown extends Vue {
  name = 'AppDropdown';

  isDropDownOpen = false;

  selectedItem: DropDownItem<number> = undefined;

  @Prop({ required: true, type: Array }) readonly items: Array<DropdownGroup<number>>;

  @Prop({ required: false, type: Object }) readonly defaultItem: DropDownItem<number>;

  @Prop({ required: false, type: Boolean }) readonly open!: boolean;

  @Prop({ required: false, type: Boolean, default: false }) readonly disabled!: boolean;

  @Prop({ required: false, type: String, default: 'auto' }) readonly optionsScrollHeight: string;

  @Watch('open')
  onOpenChanged(state: boolean) {
    this.isDropDownOpen = state;

    // will be executed when the modals gets shown or hidden
    this.$emit('on-dropdown-state-change', state);
  }

  get dropdownIcon(): string {
    return this.isDropDownOpen ? 'angle-up' : 'angle-down';
  }

  get dropDownOptionsStyle() {
    return {
      maxHeight: this.optionsScrollHeight,
      animationDuration: '0.5s',
    };
  }

  onFocusLeave(): void {
    if (this.isDropDownOpen) {
      this.isDropDownOpen = false;
      this.$emit('on-close-dropdown');
    }
  }

  /**
         * event when the item is selected in the dropdown box
         * @param item
         */
  onSelectDropdownItem(item: DropDownItem<number>) {
    this.isDropDownOpen = false;

    if (!item.disabled) {
      this.selectedItem = item;

      this.$emit('change', item);
    }
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.isDropDownOpen = !this.isDropDownOpen;

      if (this.isDropDownOpen) {
        // --- global event to close every dropdown
        this.$root.$emit('app-dropdown-close', this);
        this.$emit('on-open-dropdown');

        return;
      }

      this.$emit('on-close-dropdown');
    }
  }

  beforeMount(): void {
    if (this.defaultItem !== undefined) {
      this.selectedItem = this.defaultItem;
    }
  }

  mounted(): void {
    // event bus for preventing multiple open dropdowns,
    // since they can exist multiple instances in different components
    this.$root.$on('app-dropdown-close', (data) => {
      if (data !== this) {
        this.isDropDownOpen = false;
      }
    });
  }
}
